import {gql, useMutation} from "@apollo/client";

const ARCHIVE_DIVISION_MUTATION = gql`
mutation ArchiveDivision($divisionId: Int!) {
  archiveDivision(divisionId: $divisionId) {
    success
  }
}
`;

export default function ArchiveDivisionMutation() {
    return useMutation(ARCHIVE_DIVISION_MUTATION);
}